import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cl_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const orgId = localStorage.getItem("cl_active_org");
  if (orgId) config.headers["X-Org-Id"] = orgId;
  return config;
});

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function authHeaders() {
  const token = localStorage.getItem("cl_token") || "";
  const orgId = localStorage.getItem("cl_active_org") || "";
  const h = {};
  if (token) h.Authorization = `Bearer ${token}`;
  if (orgId) h["X-Org-Id"] = orgId;
  return h;
}
